export const Segments = [
  {
    value: 6,
    label: 'SCTE Program Start'
  },
  {
    value: 1,
    label: 'Reference Media'
  },
  {
    value: 2,
    label: 'SCTE(Splice)'
  },
  // {
  //     value: 3,
  //     label: 'GFX'
  // },
  {
    value: 4,
    label: 'Underplay'
  },
  {
    value: 5,
    label: 'Promo'
  },
  {
    value: 10,
    label: 'Media'
  },
  // {
  //     value: 8,
  //     label: 'Slate'
  // },
  {
    value: 9,
    label: 'Black'
  },
  {
    value: 7,
    label: 'SCTE Program End'
  }
]
export const LogoConfig = [
  {
    value: 'Logo on',
    label: 'Logo on',
    file: true,
    In: true,
    Out: false
  },
  {
    value: 'Logo off',
    label: 'Logo off',
    file: false,
    In: false,
    Out: true
  }
]
export const ScteType = [
  {
    value: 'SCTE only',
    label: 'SCTE only',
    file: false,
    In: false,
    Out: false
  },
  {
    value: 'Underplay clip',
    label: 'Underplay clip',
    file: false,
    In: false,
    Out: false
  }
]
export const UnderplayType = [
  {
    value: 'Ad Underplay',
    label: 'Underplay',
    file: true,
    In: true,
    Out: true
  },
  {
    value: 'Promo Media',
    label: 'Promo Media',
    file: true,
    In: true,
    Out: true
  },
  {
    value: 'Slate',
    label: 'Slate',
    file: true,
    In: true,
    Out: true
  }
]
export default {
  Segments,
  LogoConfig,
  ScteType,
  UnderplayType
}
